import React from "react";

const FormHistoryCards = ({ entries = [] }) => {
  if (!entries.length) return null;

  return (
    <div className="ds-history">
      {entries.map((entry, index) => (
        <div
          key={`${entry.title}-${entry.at}-${index}`}
          className={`ds-history__card${
            entry.isGenerated ? " ds-history__card--generated" : ""
          }`}
        >
          <div className="ds-history__title">{entry.title}</div>
          <div className="ds-history__by">{entry.by}</div>
          <div className="ds-history__at">{entry.at}</div>
        </div>
      ))}
    </div>
  );
};

export default FormHistoryCards;
